<template>
    <LayoutWithContainer :small="true">
        <div v-if="$wait.is('fetching preview resource')" class="loading">
            <Spinner :height="40" :width="40" />
        </div>
        <template v-else>
            <template slot="header">
                <ContentHeader
                    :title="sectorTitle"
                    back-link-title="Go Back"
                    :back-link="`/sectors/${sectorId}`"
                    :bordered="false"
                />
            </template>
            <template v-if="resource">
                <SectorPostCard
                    :resource="resource"
                    :sector-id="sectorId"
                    :show-read-more="false"
                    v-on:model-updated="handleModelUpdate"
                    @deleted="handleDelete"
                />
            </template>
            <div v-else class="failed">
                <span>This post may have been deleted or is no longer available.</span>
            </div>
        </template>
    </LayoutWithContainer>
</template>
<script>
import API from '@api';
import ResourcePreview from '@components/ResourcePreview';
import Spinner from '@components/Spinner';
import LayoutBase from "@layouts/LayoutBase";
import LayoutWithContainer from '@layouts/LayoutWithContainer';
import ContentHeader from '@components/Header/ContentHeader';

import SectorPostCard from './Card';
import Sectors from '../../../sectors';

export default {
    name: "SectorPostView",
    mixins: [ ResourcePreview ],
    components: {
        ContentHeader,
        LayoutWithContainer,
        Spinner,
        LayoutBase,
        SectorPostCard,
    },
    props: {
        sectorId: {
            type: Number,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            resource: null,
            deleteModal: {
                title: 'Delete resource?',
                content: 'This action cannot be undone and the user will be notified.',
                buttonLabel: 'Delete resource',
            },
        }
    },
    computed: {
        sectorTitle: function(){
            if(Sectors){
                const foundSector = Sectors.find((sector) => sector.id === this.sectorId);

                if(foundSector){
                    return foundSector.name;
                }
            }

            return null;
        }
    },
    methods: {
        async fetchResource() {
            try {
                return await API.getSectorPost(this.id);
            } catch(err) {
                console.warn({err});
            }
        },
        handleModelUpdate(newResource) {
            if(newResource){
                this.resource = newResource;
            }
        },
        handleDelete() {
            this.$router.replace({
                name: 'sector-single-view',
                params: {
                    sector_id: this.sectorId
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">

</style>
